import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NPaymentMethods } from "../../enums/nPaymentMethod.enum";
import { ServicePayLoadTemplate } from "../../models/servicePayloadTemplate.model";
import { ServiceTemplatePayload } from "../../models/serviceTemplatePayload.model";
import { SigningType } from "../../models/signing-Type.enum";
import { AgentService, AgentServicesClient, DeliverService, DeliverServicesClient, DocumentServiceClient, DocumentServiceRequest, DocumentServiceRequestClient, DocumentServices, NServices, Organization, PaymentClient, ServiceClient, ServiceProvider, ServiceRequest, ServiceRequestClient, ServiceRequestTemplate, ServiceRequestTemplateClient, ShippingMethod, ShippingMethodClient, SrPayment, UploadClient, UserProfile } from "../../web-api-client";
import { WtStorageService } from "../../wt-storage.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../environments/environment";
import { forkJoin, Subject } from "rxjs";
import { ServiceRequestResponseTypes } from "../../shared/enum/serviceRequestResponseTypes.enum";
import { ServiceRequestResponseTypeUtil } from "src/app/shared/utils/service-request-response.utils";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-service-request-component',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceRequestComponent implements OnInit {

public onClose:Subject<boolean> = new Subject<boolean>();
  public isLoaded: boolean = false;
  public currentUser: UserProfile;
  public currentOrganisation: Organization;
  public serviceProviders: DeliverService[] = [];
  public selectedSProvider: DeliverService;
  public selectedService: NServices;
  public currentStep: number = 1;
  public allServices: NServices[] = [];
  public alldocServices: DocumentServices[] = [];
  public uploadedDocumentServiceRequests: DocumentServiceRequest[] = [];
  public serviceTemplates: ServiceRequestTemplate;
  public serviceTemplatePayloads: ServiceTemplatePayload;
  public agentServices: AgentService[] = [];
  public shippingMethods: ShippingMethod[] = [];
  public selectedShippingMethod: ShippingMethod | null = null;
  public deliveredDate: Date | null = null;

  public serviceRequest: ServiceRequest = undefined;

  personalInfoForm: FormGroup;
  serviceForm: FormGroup;
  public uploadForm: FormGroup;

  public selectedMethod: NPaymentMethods = NPaymentMethods.CreditCard; // Default selection

  // Convert Enum to Array for *ngFor
  public paymentMethods = Object.keys(NPaymentMethods)
    .filter(key => !isNaN(Number(NPaymentMethods[key])))
    .map(key => ({ name: key, value: NPaymentMethods[key] }));

  public selectedResponseType: number = +ServiceRequestResponseTypes.None;

  public responseTypes = Object.keys(ServiceRequestResponseTypes)
    .filter(key => !isNaN(Number(ServiceRequestResponseTypes[key])))
    .map(key => ({ name: key, value: ServiceRequestResponseTypes[key] }));


  public searchQuery: string = '';
  public filteredNServices: NServices[] = this.allServices;
  filteredServiceProviders: DeliverService[] = this.serviceProviders;


  constructor(private fb: FormBuilder, public localStorage: WtStorageService, public activeModal: NgbActiveModal, public uploadClient: UploadClient, public documentServiceClient: DocumentServiceClient, public serviceClient: ServiceClient,
    public changeDetectRef: ChangeDetectorRef, private toastr: ToastrService, public agentServiceClient: AgentServicesClient, public paymentServiceClient: PaymentClient, public deliverService: DeliverServicesClient, public serviceReqTemplateClient: ServiceRequestTemplateClient, public serviceRequestClient: ServiceRequestClient, public documentServiceRequestClient: DocumentServiceRequestClient, public shippingMethodClient: ShippingMethodClient) {
    this.personalInfoForm = this.fb.group({
      firstName: ['', Validators.required],
      middleName: ['', Validators.required],
      familyName: ['', Validators.required],
      egn: ['', Validators.required],
      address: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      onBehalf: [false, Validators.required],
    });

    this.serviceForm = this.fb.group({
      selectedService: ['', Validators.required],
    });

    this.uploadForm = this.fb.group({
      documentTitle: ['', Validators.required],
      documentType: ['', Validators.required],
      fileUpload: ['', Validators.required]
    });


  }
  ngOnInit(): void {

    this.currentUser = this.localStorage.getuser();
    this.currentOrganisation = this.currentUser.organization;

    // Load shipping methods
    this.shippingMethodClient.getList().subscribe(methods => {
      this.shippingMethods = methods.filter(m => m.isActive);
      this.changeDetectRef.detectChanges();
    });

    if (this.currentUser.organization.agentId && this.currentUser.organization.agentId > 0) {
      this.agentServiceClient.getServiceListByAgent(this.currentUser.organization.agentId).subscribe(agentServices => {
        this.agentServices = agentServices;
        this.isLoaded = true;
        this.changeDetectRef.detectChanges();
      });
    }
    else {
      this.isLoaded = true;
      this.changeDetectRef.detectChanges();
    }

    this.setupEnterKeyListener();
  }

  setupEnterKeyListener() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        this.filterServices();
        this.filterServiceProviders();
        this.changeDetectRef.detectChanges();
      }
    });
  }

  close() {
    this.activeModal.close();
  }


  onClickOk(){
    this.onClose.next(true);
    this.activeModal.close();
  }

  proceedToNextStep() {


    if (this.currentStep == 2) {

      if (this.selectedService) {

        forkJoin([this.deliverService.getListServiceProvidersByServiceId(this.selectedService.idService), this.documentServiceClient.getListByService(+this.selectedService.idService)])
          .subscribe(([services, documents]) => {

            this.serviceProviders = services;
            this.filteredServiceProviders = services;
            this.alldocServices = documents;
            this.currentStep++;
            this.updateStep();
            this.changeDetectRef.detectChanges();

          });

      }
      else {

      }
    } else if (this.currentStep == 1) {

      console.log(this.selectedResponseType);

      this.serviceClient.getList().subscribe(services => {

        this.allServices = services;
        this.filteredNServices = services;
        this.currentStep++;
        this.updateStep();
        this.changeDetectRef.detectChanges();

      })

    } else if (this.currentStep == 3) {

      this.serviceReqTemplateClient.getById(this.selectedService.idService).subscribe(templates => {

        this.serviceTemplates = templates;
        this.serviceTemplatePayloads = new ServiceTemplatePayload();

        if (templates != null) {

          this.serviceTemplatePayloads.templateId = templates.idServiceRequestTemplate;

          if (templates.payLoad)
            this.serviceTemplatePayloads.payloads = JSON.parse(templates.payLoad);
        }


        this.currentStep++;
        this.updateStep();
        this.changeDetectRef.detectChanges();

      })

    }
    else if (this.currentStep == 4) {

      this.showTemplates = false;





      let agentServcie = this.agentServices.find(d => d.idService == this.selectedService.idService);

      let model = new ServiceRequest({
        firstName: this.personalInfoForm.value.firstName,
        surName: this.personalInfoForm.value.middleName,
        fammily: this.personalInfoForm.value.familyName,
        egn: this.personalInfoForm.value.egn,
        address: this.personalInfoForm.value.address,
        phone: this.personalInfoForm.value.phone,
        email: this.personalInfoForm.value.email,
        sendOnBehalf: this.personalInfoForm.value.onBehalf,
        responseType: this.selectedResponseType,
        request: JSON.stringify(this.serviceTemplates),
        operatorId: this.currentUser.id,
        idDeliversService: this.selectedSProvider.idDeliversService,
        idAgentsService: 0,
        serviceAgentComission: this.getAgentComission(),
        serviceProviderTax: this.selectedSProvider?.deliverTaxe,
        deliverService: null,
        agentService: null,
        idShippingMethod: this.selectedShippingMethod?.idShippingMethod,
        deliveredDate: this.deliveredDate
      });

      if (agentServcie) {
        model.idAgentsService = agentServcie.idAgentsService;
      }

      if (this.serviceTemplatePayloads) {
        model.response = JSON.stringify(this.serviceTemplatePayloads);
      }


      this.serviceRequestClient.create(model).subscribe(r => {

        model.idServiceRequest = r;
        this.serviceRequest = model;

        if (this.uploadedDocumentServiceRequests && this.uploadedDocumentServiceRequests.length > 0) {

          this.uploadedDocumentServiceRequests.forEach(d => {
            d.idServiceRequest = r;
          });


          this.documentServiceRequestClient.createList(this.uploadedDocumentServiceRequests).subscribe(r => {

            this.showTemplates = false;

            this.currentStep++;
            this.updateStep();
            this.changeDetectRef.detectChanges();


          });



        }
        else {

          this.showTemplates = false;

          this.currentStep++;
          this.updateStep();
          this.changeDetectRef.detectChanges();
        }



      })

    }
    else if (true) {
      this.currentStep++;
      this.updateStep();

      this.changeDetectRef.detectChanges();
    }
  }

  nextStep() {
    this.currentStep++;
    this.updateStep();
  }

  prevStep() {

    if (this.currentStep == 4) {
      this.uploadedDocumentServiceRequests = [];
    }
    else if (this.currentStep == 5) {
      this.showTemplates = true;
    }

    this.currentStep--;
    this.updateStep();
  }

  isStepCompleted(step: number): boolean {
    return this.currentStep >= step;
  }

  updateStep() {
    for (let i = 1; i <= 7; i++) {
      document.getElementById(`step${i}`).classList.add('d-none');
    }
    document.getElementById(`step${this.currentStep}`).classList.remove('d-none');
  }

  public onUserSelected(service: DeliverService) {
    if (this.isSelected(service)) {
      this.selectedSProvider = null;
    }
    else {

      this.selectedSProvider = service;
    }

    this.changeDetectRef.detectChanges();

  }

  public isSelected(service: DeliverService): boolean {
    let result = this.selectedSProvider != null && this.selectedSProvider == service;

    return result;

  }

  public isEnabled(): boolean {

    if (this.currentStep == 4) {

      return this.selectedSProvider ? true : false;
    }
    else if (this.currentStep == 2) {
      return this.selectedService ? true : false;
    }
    else if (this.currentStep == 3) {

      let uploadedDocs = this.getUploadableDocuments();

      let stillRequired = uploadedDocs.some(r=>r.isRequired);
      return stillRequired ? false : true;
    }
    else if (this.currentStep == 6 || this.currentStep == 7) {
      return false;
    }

    return true;
  }

public showOkButton(): boolean {
return this.currentStep==8;
}
  public isHidden(): Boolean {
    return this.currentStep == 6 || this.currentStep == 7;
  }

  public downloadDocument(path: string): void {
    let usedPath = path.replace('wwwroot', '');
    window.open(environment.BackEndApi + usedPath, '_blank');
  }


  onSubmit() {
    if (this.uploadForm.valid) {
      const formData = new FormData();
      const formValue = this.uploadForm.value;

      this.uploadClient.uploadDocument(formValue.documentTitle, formValue.documentType, formValue.file).subscribe((f) => {

        console.log(f);

      });
    } else {
      console.log('Form is not valid');
    }
  }



  requireSign(document: DocumentServices): string {
    return document.documents.signedType == SigningType.SignRequired ? 'Изисква Подпис' : 'Не изисква подпис';
  }

  onFileUpload(event: any, documentId: number): void {
    let response: { dbPath: '' };
    response = event;
    let doc = new DocumentServiceRequest({ documentPath: response.dbPath, documentsIdDocument: documentId, idDocumentServiceRequest: 0 });

    this.uploadedDocumentServiceRequests = this.uploadedDocumentServiceRequests.filter(d => d.documentsIdDocument != documentId);
    this.uploadedDocumentServiceRequests.push(doc);

    this.changeDetectRef.detectChanges();
  }

  public getUploadableDocuments(): DocumentServices[] {

    let docs = this.alldocServices.filter(r => !this.uploadedDocumentServiceRequests.find(d => d.documentsIdDocument == r.documentsIdDocument));

    docs.sort((a, b) => {
      // Assuming 'order' is a numeric property of 'Document'
      return a.order - b.order;
    });

    return docs;
  }

  public isDocumentUploaded(docService: DocumentServices): boolean {

    return this.uploadedDocumentServiceRequests.some(d => d.documentsIdDocument == docService.documentsIdDocument);
  }

  public getSortedDocumentServices(): DocumentServices[] {
    let docs = this.alldocServices.sort((a, b) => {
      // Assuming 'order' is a numeric property of 'Document'
      return a.order - b.order;
    });

    return docs;
  }

  public getFileNameAndExtension(documentService:DocumentServices): string {
  // Extract the filename from the path

    let uplaodedDoc = this.uploadedDocumentServiceRequests.find(a => a.documentsIdDocument == documentService.documentsIdDocument);
    const fileNameWithExtension = uplaodedDoc.documentPath.split('\\').pop() || '';
    return fileNameWithExtension;
}



  public showTemplates: boolean = true;

  public getRequestorNames(): string {

    if (!this.serviceRequest) {
      return '';
    }

    return `${this.serviceRequest.firstName} ${this.serviceRequest.fammily} с ЕГН: ${this.serviceRequest.egn}`
  }

  public getServiceProviderName(): string {
    if (!this.selectedSProvider) {
      return '';
    }

    return this.selectedSProvider.serviceProvider.serviceProviderName;
  }

  public getTotalServiceFee() {

    if (!this.selectedSProvider) {
      return 0;
    }

    let agentService = this.agentServices.find(d => d.idService == this.selectedService.idService);

    let agentTax = agentService ? agentService.agentCommission : 0;
    let totalSum = this.selectedSProvider.deliverTaxe + agentTax;

    return parseFloat(totalSum.toFixed(2));
  }

  public getAgentComission() {

    let agent = this.localStorage.getАgent();

    if (!this.agentServices || !this.selectedSProvider)
      return agent.defaultComission;

    let agentService = this.agentServices.find(d => d.idService == this.selectedService.idService);
    return agentService ? agentService.agentCommission : 0;
  }

  public processPayment() {
    // Your payment logic here

    let paymentModel = new SrPayment(
      {
        serviceRequestId: this.serviceRequest.idServiceRequest,
        operatorId: this.currentUser.id,
        paymentMethod: this.selectedMethod
      });

    this.paymentServiceClient.create(paymentModel).subscribe(pm => {

      this.toastr.success("Плащанетоп беше, извършено успешно.", "Успешно Запазване", {
        timeOut: 3000,
      });
      this.currentStep++;
      this.updateStep();
    })


  }

  filterServices() {
    if (this.searchQuery) {
      this.filteredNServices = this.allServices.filter(service =>
      service.serviceName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
      service.yri.toLowerCase().includes(this.searchQuery.toLowerCase()));

    } else {
      this.filteredNServices = this.allServices;
    }
  }

  filterServiceProviders() {
    if (this.searchQuery) {
      this.filteredServiceProviders = this.serviceProviders.filter(sProvider =>
        sProvider.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        sProvider.service.serviceName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        sProvider.service.yri.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        sProvider.serviceProvider.serviceProviderName.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredServiceProviders = this.serviceProviders;
    }
  }


  selectService(service: NServices) {
    this.selectedService = service;
  }

  public GetCyrilicRequestType(requestType: ServiceRequestResponseTypes): string {

    return ServiceRequestResponseTypeUtil.getCyrilicLabel(requestType);
  }

  onResponseTypeChange(newType: any) {
    this.selectedResponseType = newType.target.value;
    // Perform any other actions based on the new selection
    // For example, updating other fields or making API calls
  }

  public trimAndEllipsize(text: string,length:number): string {
    const maxLength = length;
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
}

  handlePaymentStatus(status: boolean) {
    if (status) {
      this.processPayment();
    } else {
      this.toastr.error("Възникна Грешка при Плащането", "Грешка", {
        timeOut: 3000,
      });
    }
  }


}

